export default "__VITE_ASSET__69da9ad9__"